import { LanguageTypes } from "../../../translations/LanguageTypes";

export const PRODUCT_INFO_ARTICLES_CATEGORIES = {
  MARKETING_MATERIAL_DEFAULT: 'MARKETING_MATERIAL_DEFAULT',
  SALES_MATERIAL_DEFAULT: 'SALES_MATERIAL_DEFAULT',
  SALES_MATERIAL_FRANCE: 'SALES_MATERIAL_FRANCE',
};

export const DEVELOPERS_ARTICLES_CATEGORIES = {
  INTRO: 'INTRO',
  API: 'API',
  SDK: 'SDK',
  KNX: 'KNX',
};

export const ProductInfoArticlesMap = [
  {
    name: PRODUCT_INFO_ARTICLES_CATEGORIES.MARKETING_MATERIAL_DEFAULT,
    categoryId: 124,
    postIds: {
      [LanguageTypes.DUTCH]: 7334,
      [LanguageTypes.ENGLISH]: 7313,
      [LanguageTypes.FRENCH]: 7336,
      [LanguageTypes.GERMAN]: 7338,
      [LanguageTypes.ITALIAN]: 7340,
      [LanguageTypes.SPANISH]: 7342,
    },
  },
  {
    name: PRODUCT_INFO_ARTICLES_CATEGORIES.SALES_MATERIAL_DEFAULT,
    categoryId: 107,
    postIds: {
      [LanguageTypes.DUTCH]: 7358,
      [LanguageTypes.ENGLISH]: 7317,
      [LanguageTypes.FRENCH]: 7360,
      [LanguageTypes.GERMAN]: 7362,
      [LanguageTypes.ITALIAN]: 7364,
      [LanguageTypes.SPANISH]: 7366,
    },
  },
  {
    name: PRODUCT_INFO_ARTICLES_CATEGORIES.SALES_MATERIAL_FRANCE,
    categoryId: 107,
    postIds: {
      [LanguageTypes.DUTCH]: 7348,
      [LanguageTypes.ENGLISH]: 7344,
      [LanguageTypes.FRENCH]: 7350,
      [LanguageTypes.GERMAN]: 7352,
      [LanguageTypes.ITALIAN]: 7356,
      [LanguageTypes.SPANISH]: 7354,
    },
  },
]

export const VashoManualArticlesMap = [
  {
    name: 'VASHO_MANUAL',
    categoryId: 107,
    postIds: {
      [LanguageTypes.ENGLISH]: 8811,
      [LanguageTypes.FRENCH]: 8960,
      [LanguageTypes.GERMAN]: 8966,
      [LanguageTypes.ITALIAN]: 8958,
      [LanguageTypes.SPANISH]: 8962,
      [LanguageTypes.DUTCH]: 8838,
    },
  },
]

export const ISEO_TRAINING_MATERIALS_ARTICLE_NAME = 'ISEO_TRAINING_MATERIALS';

export const IseoTrainingMaterialsArticlesMap = [
  {
    name: ISEO_TRAINING_MATERIALS_ARTICLE_NAME,
    postIds: {
      [LanguageTypes.ENGLISH]: 9869,
      [LanguageTypes.ITALIAN]: 9902,
      [LanguageTypes.FRENCH]: 9896,
      [LanguageTypes.GERMAN]: 9898,
      [LanguageTypes.SPANISH]: 9906,
      [LanguageTypes.DUTCH]: 9894,
    },
  },
];

export const DevelopersArticlesMap = [
  {
    name: DEVELOPERS_ARTICLES_CATEGORIES.INTRO,
    postIds: {
      [LanguageTypes.ENGLISH]: 9657,
      // [LanguageTypes.FRENCH]: 8960,
      // [LanguageTypes.GERMAN]: 8966,
      // [LanguageTypes.ITALIAN]: 8958,
      // [LanguageTypes.SPANISH]: 8962,
      // [LanguageTypes.DUTCH]: 8838,
    },
  },
  {
    name: DEVELOPERS_ARTICLES_CATEGORIES.API,
    postIds: {
      [LanguageTypes.ENGLISH]: 9630,
      // [LanguageTypes.FRENCH]: 8960,
      // [LanguageTypes.GERMAN]: 8966,
      // [LanguageTypes.ITALIAN]: 8958,
      // [LanguageTypes.SPANISH]: 8962,
      // [LanguageTypes.DUTCH]: 8838,
    },
  },
  {
    name: DEVELOPERS_ARTICLES_CATEGORIES.SDK,
    postIds: {
      [LanguageTypes.ENGLISH]: 9562,
      // [LanguageTypes.FRENCH]: 8960,
      // [LanguageTypes.GERMAN]: 8966,
      // [LanguageTypes.ITALIAN]: 8958,
      // [LanguageTypes.SPANISH]: 8962,
      // [LanguageTypes.DUTCH]: 8838,
    },
  },
  {
    name: DEVELOPERS_ARTICLES_CATEGORIES.KNX,
    postIds: {
      [LanguageTypes.ENGLISH]: 9695,
      // [LanguageTypes.FRENCH]: 8960,
      // [LanguageTypes.GERMAN]: 8966,
      // [LanguageTypes.ITALIAN]: 8958,
      // [LanguageTypes.SPANISH]: 8962,
      // [LanguageTypes.DUTCH]: 8838,
    },
  },
]